import { InfoCircleOutlined } from "@ant-design/icons";
import { Alert, Breadcrumb, Button, Card, Checkbox, Col, Divider, Flex, Form, Radio, Row, Space, Switch, Tooltip } from "antd";
import { useForm } from "antd/es/form/Form";
import { Footer } from "antd/es/layout/layout";
import { CardContainer } from "components/elements";
import { FormDatePicker, FormSegmented, FormSelect, RequiredMark } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import MainLayout from "components/layouts/MainLayout/MainLayout_2";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import OnePeriod from "./PayrollPayment/OnePeriod";
import ThreePeriod from "./PayrollPayment/ThreePeriod";
import TwoPeriod from "./PayrollPayment/TwoPeriod";
import WeeklyPeriod from "./PayrollPayment/WeeklyPeriod";
import FormSwitch from "components/form/FormProvide/FormSwitch";

const PayrollCreatePeriod = ({
    initialValues = { paymentPeriodType: "1" },
    employmentTypeDropdown = () => { },
    startOnFlowHrDropdown = () => { },
    getStartPerionOnFlowHr = () => { },
    onSubmit = () => { },
    handleCancel = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const [form] = useForm(null);
    const [value, setValue] = useState('1');

    const tooltipText = <span>To calculate the income or deduction which are made outside of the regular period and paid in the current period.</span>
    console.log("startOnFlowHrDropdown()", startOnFlowHrDropdown());

    const [optionWeek, setOptionWeek] = useState([])

    const optionsWeek = useCallback(
        () => {
            let list = []

            for (let index = 0; index < 7; index++) {
                let date = dayjs().day(index).locale("en");
                const day = date.format("dddd");

                list.push({
                    value: day.toLowerCase(),
                    label: date.locale(i18n.language.toLowerCase()).format(i18n.language === 'th' ? "ddd" : "dddd")
                })

            }
            setOptionWeek([...list])
        },
        [i18n.language],
    )

    useEffect(() => {
        optionsWeek()
    }, [i18n.language, optionsWeek])

    const renderPeriodComponent = (params) => {
        switch (value) {
            case '1':
                return <OnePeriod setFieldValue={form.setFieldValue} values={{ ...params }} />;
            case '2':
                return <TwoPeriod setFieldValue={form.setFieldValue} values={{ ...params }} />;
            case '3':
                return <ThreePeriod setFieldValue={form.setFieldValue} values={{ ...params }} />;
            case '4':
                return <WeeklyPeriod options={optionWeek} />;
            default:
                return null;
        }
    };

    function message(values) {
        let dropdown = [...startOnFlowHrDropdown()]
        const startDate = dropdown?.[0]?.startDate
            ? dayjs(dropdown[0].startDate).format(i18n.language === "en" ? "DD MMMM YYYY" : "DD MMMM BBBB")
            : "-";
        const endDate = dropdown?.[dropdown?.length - 1]?.endDate
            ? dayjs(dropdown[dropdown.length - 1].endDate).format(i18n.language === "en" ? "DD MMMM YYYY" : "DD MMMM BBBB")
            : "-";

        function period() {
            if (values?.paymentPeriodType === "1") {
                return 12;
            }
            else if (values?.paymentPeriodType === "2") {
                return 24;
            }
            else if (values?.paymentPeriodType === "3") {
                return 36;
            }
            else if (values?.paymentPeriodType === "4") {
                return 48;
            }
            else {
                return null
            }
        }

        return (i18n.language === "en" ? `Payroll periods will be generated from  ${startDate} - ${endDate} (Total of ${period()} Periods) and started to calculate on Flow Hr from the period no. ${values.startPeriodOnFlowHr + 1} /${period()}` : `ระบบจะนับงวดเงินเดือนให้ตั้งแต่วันที่  ${startDate} - ${endDate} (รวม ${period()} งวด) โดยเริ่มทำเงินเดือนบน Flow HR ตั้งแต่งวดที่ ${values.startPeriodOnFlowHr + 1} /${period()}`)
    }

    return (
        <MainLayout>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("payroll.header"), href: "/payroll" },
                        { title: t("payroll.all"), href: "/payroll" },
                        { title: t("payroll.create_payroll_period") },
                    ]} />
                    <h2>{t("payroll.create_payroll_period")}</h2>
                </Flex>
                <Card style={{ border: "solid 1px #EAECF0" }}>
                    <Space style={{ width: "100%", padding: "3vw" }} direction="vertical" size={24}>
                        <FormAntd
                            form={form}
                            initialValues={{ ...initialValues, taxYear: dayjs(), paymentPeriodType: "1" }}
                            onFinish={onSubmit}
                            requiredMark={RequiredMark}
                            colon={false}
                        >
                            <Form.Item shouldUpdate={(prev, curv) => {
                                if (prev['startOfFirstPeriod'] != curv['startOfFirstPeriod']) {
                                    getStartPerionOnFlowHr(curv)
                                }

                                return prev['taxYear'] != curv['taxYear']
                                    || prev['startOfFirstPeriod'] != curv['startOfFirstPeriod']
                                    || prev['startPeriodOnFlowHr'] != curv['startPeriodOnFlowHr']
                                    || prev['employmentType'] != curv['employmentType']
                                    || prev['offCyclePayroll'] != curv['offCyclePayroll']
                            }}>
                                {({ getFieldValue, getFieldsValue, setFieldValue }) =>
                                    <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                        {/* <Row> */}
                                        <Flex vertical>
                                            <h3>{t('payroll.taxYear')}</h3>
                                            <Col span={6}>
                                                <FormDatePicker
                                                    name="taxYear"
                                                    dateFormat={"YYYY"}
                                                    label={t("payroll_period.label.tax_year")}
                                                    required={true}
                                                    size="large"
                                                    picker="year"
                                                    placeholder={t("common.pleaseSelect")} />
                                            </Col>
                                        </Flex>
                                        {/* <Col span={19}></Col> */}

                                        <Flex vertical>
                                            <h3>{t("payroll.employment_type")}</h3>
                                            <Col span={6}>
                                                <FormSelect
                                                    required={true}
                                                    disabled={getFieldValue('taxYear') == null}
                                                    fontWeight="regular"
                                                    name="employmentType"
                                                    label={t("payroll_period.employment_type")}
                                                    placeholder={t("common.pleaseSelect")}
                                                    size="large"
                                                    options={employmentTypeDropdown()}
                                                    mode="multiple"
                                                    maxCount={1}
                                                />
                                            </Col>
                                        </Flex>
                                        {/* <Col span={18}></Col> */}

                                        {/* </Row> */}

                                        <Flex vertical>
                                            <h3>{t("payroll_period.payment_period")}</h3>
                                            <Col span={15}>
                                                <FormSegmented
                                                    name="paymentPeriodType"
                                                    label={t("payroll_period.payment_period_type")}
                                                    required={true}
                                                    size="large"
                                                    options={[
                                                        { value: "1", label: t("payroll_period.label.one_period") },
                                                        { value: "2", label: t("payroll_period.label.two_period") },
                                                        { value: "3", label: t("payroll_period.label.three_period") },
                                                        { value: "4", label: t("payroll_period.label.weekly_period") },
                                                    ]}
                                                    value={value}
                                                    onChange={(e) => {
                                                        setValue(e)
                                                        setFieldValue("paymentPeriodType", e)
                                                        setFieldValue("startOfFirstPeriod", null)
                                                        setFieldValue("startPeriodOnFlowHr", null)
                                                    }} />
                                            </Col>
                                        </Flex>

                                        <Flex gap={16}>
                                            <Col span={6}>
                                                <FormDatePicker
                                                    name="startOfFirstPeriod"
                                                    disabled={getFieldValue('employmentType') == null || getFieldValue('employmentType')?.length == 0}
                                                    label={t("payroll_period.label.start_of_first_period")}
                                                    required={true}
                                                    size="large"
                                                    placeholder={t("common.pleaseSelect")}
                                                    picker="date"
                                                    minDate={getFieldValue('taxYear').startOf('year').add(-2, 'month')}
                                                    maxDate={getFieldValue('taxYear').endOf('year')}
                                                    // disabledDate={(current) => {
                                                    //     const selectedYear = getFieldValue('taxYear')?.year();
                                                    //     return current && current.year() !== parseInt(selectedYear);
                                                    // }}
                                                    // disabledDate={(current) => current && current.date() >= 29}
                                                    onChange={(e) => {
                                                        getStartPerionOnFlowHr(getFieldsValue(true));
                                                    }} />
                                            </Col>
                                            <Col span={6}>
                                                <FormSelect
                                                    name="startPeriodOnFlowHr"
                                                    disabled={getFieldValue('startOfFirstPeriod') == null}
                                                    label={t("payroll_period.label.start_period_on_flowhr")}
                                                    placeholder={t("common.pleaseSelect")}
                                                    required={true}
                                                    size="large"
                                                    sortBy={"null"}
                                                    options={startOnFlowHrDropdown()}
                                                    onChange={(e) => {
                                                        console.log("e", e, startOnFlowHrDropdown().find(o => o.value === e));
                                                    }}
                                                />
                                            </Col>
                                        </Flex>
                                        {getFieldValue("startPeriodOnFlowHr") != null ? (
                                            <Row>
                                                <Alert
                                                    message={message(getFieldsValue(true))}
                                                    type="warning"
                                                    showIcon />
                                            </Row>
                                        ) : null}

                                        <Form.Item
                                            noStyle
                                            shouldUpdate={(prev, cur) => prev["socialSprint"] !== cur["socialSprint"]}
                                        >
                                            {({ getFieldValue, setFieldValue }) => {
                                                const isOpen = !!getFieldValue("socialSprint");
                                                return (
                                                    <Flex vertical gap={8}>
                                                        <FormSwitch
                                                            vertical={false}
                                                            label={t("employee.label.employeeSalarySocialSecurity")}
                                                            checked={isOpen}
                                                            onChange={(checked) => {
                                                                if (!checked) {
                                                                    setFieldValue("socialSprint", null);
                                                                } else {
                                                                    setFieldValue("socialSprint", "everySprint");
                                                                }
                                                            }}
                                                        />

                                                        {isOpen && (
                                                            <Radio.Group
                                                                style={{ height: "fit-content" }}
                                                                name="socialSprint"
                                                                value={getFieldValue("socialSprint")}
                                                                onChange={(e) => setFieldValue("socialSprint", e.target.value)}
                                                            >
                                                                <Space direction="vertical">
                                                                    <Radio value="everySprint">
                                                                        {t("payroll_period.label.every_sprint")}
                                                                    </Radio>
                                                                    <Radio value="lastSprint">
                                                                        {t("payroll_period.label.last_sprint")}
                                                                    </Radio>
                                                                </Space>
                                                            </Radio.Group>
                                                        )}
                                                    </Flex>
                                                );
                                            }}
                                        </Form.Item>

                                        {
                                            !(
                                                getFieldValue("taxYear") != null
                                                && getFieldValue("paymentPeriodType") != null
                                                && getFieldValue("startOfFirstPeriod") != null
                                                && getFieldValue("startPeriodOnFlowHr") != null
                                            )
                                                ? "" :
                                                <>
                                                    <Divider style={{ borderColor: "#EAECF0", borderWidth: "1px" }} />

                                                    <Flex vertical>
                                                        <h3>{t("payroll_period.payroll_payment")}</h3>
                                                        <Row >
                                                            {renderPeriodComponent(getFieldsValue())}
                                                        </Row>
                                                        <Row style={{ marginTop: "12px" }}>
                                                            <Form.Item noStyle name="allowPayBeforeHoliday" initialValue="N">
                                                                <Checkbox
                                                                    onChange={(e) => {
                                                                        setFieldValue("allowPayBeforeHoliday", e.target.checked ? "Y" : "N")
                                                                    }}
                                                                >
                                                                    {i18n.language === "en"
                                                                        ? "If the payday falls on a holiday, the employees will receive the payment on the previous day."
                                                                        : "หากวันจ่ายเงินตรงกับวันหยุด พนักงานจะได้รับเงินเดือนในวันก่อนหน้า"}
                                                                </Checkbox>
                                                            </Form.Item>
                                                        </Row>
                                                    </Flex>


                                                    <Divider style={{ borderColor: "#EAECF0", borderWidth: "1px" }} />

                                                    <Flex vertical>
                                                        <h3>
                                                            {t("payroll_period.label.other_condition")}
                                                        </h3>
                                                        <Row>
                                                            <Form.Item name="offCyclePayroll" label={<Space>
                                                                {t("payroll_period.label.off_cycle")}
                                                                <Tooltip title={tooltipText} color="#4EB8E0">
                                                                    <InfoCircleOutlined />
                                                                </Tooltip>
                                                            </Space>}

                                                            >
                                                                <Switch
                                                                    size="small" name="offCyclePayroll" />

                                                            </Form.Item>
                                                        </Row>
                                                        {getFieldValue("offCyclePayroll") && (
                                                            <Row style={{ width: "100%" }}>
                                                                <Col span={6}>
                                                                    <FormDatePicker required
                                                                        name="startCalculateOffCycle"
                                                                        label={t("payroll_period.label.start_calculating")}
                                                                        size="large"
                                                                        placeholder={t("common.pleaseSelect")}
                                                                        picker="date"
                                                                    />
                                                                </Col>
                                                            </Row>)}
                                                    </Flex>
                                                </>
                                        }

                                    </Space>
                                }
                            </Form.Item>
                            <Footer style={{
                                zIndex: 999,
                                bottom: 1,
                                position: 'sticky',
                                backgroundColor: "white",
                                height: "fit-content",
                                padding: '10px 50px',
                            }}>
                                <Row justify="end" >
                                    <Space>
                                        <Alert
                                            message={t("payment_period.label.alert")}
                                            type="error"
                                            showIcon
                                        />
                                        <Button type="default"
                                            style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}
                                            onClick={() => {
                                                handleCancel();
                                            }}>
                                            {t("common.cancel").toUpperCase()}
                                        </Button>
                                        <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
                                            {t("payroll_period.submit_period").toUpperCase()}
                                        </Button>
                                    </Space>
                                </Row>
                            </Footer>

                        </FormAntd>
                    </Space>
                </Card>
            </Space>
        </MainLayout >
    )
}

export default PayrollCreatePeriod;